// extracted by mini-css-extract-plugin
export var borderRadius = "_5r-4";
export var large = "_5r-3";
export var logoContainer = "_5r-0";
export var nameLogo = "_5r-2";
export var small = "_5r-1";